'use es6';

import I18n from 'I18n';
import { memo } from 'react';
import { PIVOT_TOO_LARGE, TABLE_TOO_LARGE, MULTI_ACCOUNT_CONFIGURATION } from 'reporting-data/constants/errorTypes';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const translate = keys => I18n.text(`reporting-visualizations.error-messages.${keys}`);
const messages = {
  [PIVOT_TOO_LARGE]: () => ({
    header: translate('pivot-too-large.header'),
    tip: translate('pivot-too-large.message')
  }),
  [TABLE_TOO_LARGE]: () => ({
    header: translate('table-too-large.header'),
    tip: translate('table-too-large.message')
  }),
  [MULTI_ACCOUNT_CONFIGURATION]: () => ({
    header: translate('multi-account-configuration.header'),
    tip: translate('multi-account-configuration.message')
  })
};
const ErrorMessage = ({
  type
}) => {
  const {
    header,
    tip
  } = messages[type]();
  return /*#__PURE__*/_jsxs(View, {
    padding: "1000",
    marginBlock: "600",
    marginInline: "auto",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx("h4", {
      children: header
    }), /*#__PURE__*/_jsx("p", {
      children: tip
    })]
  });
};
export const Render = /*#__PURE__*/memo(ErrorMessage);